import { css } from "@emotion/react";
import { ChevronRight } from "lucide-react";
import { useProductDetailsState } from "../../hooks/useProductDetailsState";

//------------------------------------------------------------------------------------
//export type DepartmentCategorySubcategoryLinksProps = {};
export const DepartmentCategorySubcategoryLinks: React.FC /*<DepartmentCategorySubcategoryLinksProps>*/ =
	() => {
		const productDetailsState = useProductDetailsState();
		const product = productDetailsState.get().product;

		if (product !== undefined) {
			return (
				<div className="flex items-center justify-center text-xs py-2 px-4">
					<span css={css`flex: 0 0 auto;`}>{product.WebCatalog ?? ""}</span>
					<ChevronRight size={12} />
					<span css={css`flex: 0 0 auto;`}>
						{product.InventoryDepartment ?? ""}
					</span>
					<ChevronRight size={12} />
					<span css={css`flex: 0 0 auto;`}>{product.Category ?? ""}</span>
					{product.SubCategoryId && (
						<>
							<ChevronRight size={12} />
							<span css={css`flex: 0 0 auto;`}>
								{product.SubCategory ?? ""}
							</span>
						</>
					)}
				</div>
			);
		}
		return null;
	};
